/* Siltcon Auréa: koopblok. Wisselt tussen 1 en 2 horloges, toont de vaste koopbalk op mobiel. */
(() => {
  /** @param {HTMLFormElement} form */
  const init = (form) => {
    if (form.dataset.aureaKlaar) return;
    form.dataset.aureaKlaar = 'true';

    const enkel = /** @type {HTMLInputElement | null} */ (form.querySelector('[data-aurea-enkel]'));
    const selects = /** @type {NodeListOf<HTMLSelectElement>} */ (form.querySelectorAll('[data-aurea-kleur]'));
    const dubbel = /** @type {NodeListOf<HTMLInputElement>} */ (form.querySelectorAll('[data-aurea-dubbel]'));
    const balk = document.querySelector('[data-aurea-balk]');
    const knop = form.querySelector('[data-aurea-knop]');

    const werkBij = () => {
      const gekozen = /** @type {HTMLInputElement | null} */ (form.querySelector('input[name="aurea_offer"]:checked'));
      const twee = gekozen?.value === '2';
      if (enkel) enkel.disabled = twee;
      selects.forEach((select) => (select.disabled = !twee));
      dubbel.forEach((input) => (input.disabled = !twee));
      form.querySelectorAll('[data-aurea-keuze]').forEach((keuze) => {
        keuze.classList.toggle('aurea-kb__keuze--gekozen', keuze.contains(gekozen));
      });
      if (balk) {
        const prijs = balk.querySelector('[data-aurea-balk-prijs]');
        const tekst = balk.querySelector('[data-aurea-balk-tekst]');
        const van = balk.querySelector('[data-aurea-balk-van]');
        const badge = balk.querySelector('[data-aurea-balk-badge]');
        if (prijs) prijs.textContent = (twee ? form.dataset.prijsTwee : form.dataset.prijsEen) ?? '';
        if (tekst) tekst.textContent = twee ? '2 horloges' : '1 horloge';
        // Van prijs en percentage uit data-van-* en data-procent-* op het formulier (snippets/aurea-koopblok.liquid).
        if (van) van.textContent = (twee ? form.dataset.vanTwee : form.dataset.vanEen) ?? '';
        if (badge) {
          const procent = twee ? form.dataset.procentTwee : form.dataset.procentEen;
          badge.textContent = procent ? `${procent}% korting` : '';
          badge.hidden = !procent;
        }
        balk.classList.toggle('aurea-kb-balk--voordeel', twee);
      }
    };

    form.querySelectorAll('input[name="aurea_offer"]').forEach((radio) => radio.addEventListener('change', werkBij));

    selects.forEach((select) =>
      select.addEventListener('change', () => {
        const beeld = /** @type {HTMLImageElement | null | undefined} */ (
          select.closest('[data-aurea-rij]')?.querySelector('img')
        );
        const bron = select.selectedOptions[0]?.dataset.beeld;
        if (beeld && bron) {
          beeld.src = bron;
          beeld.removeAttribute('srcset');
        }
      })
    );

    werkBij();

    if (balk && knop && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry) balk.classList.toggle('aurea-kb-balk--aan', !entry.isIntersecting);
      }).observe(knop);
    }
  };

  const start = () => document.querySelectorAll('form[data-aurea-koop]').forEach((form) => init(/** @type {HTMLFormElement} */ (form)));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
